import { useEffect } from 'react';
import {
  getPharmacyRating,
  getPharmacyRatingItems,
  getRating,
  getRatingItems,
  getTypeOfUser,
  HelpTypes,
  pharmacyActions,
  pharmacyRating,
  pharmacyRatingItems,
  professionalActions,
  rating,
  ratingItems,
  TypeOfUser,
} from '@pharmaplan/common';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

const { pharmacist, pharmacy, technician, student } = TypeOfUser;

const useViewRating = (id: string) => {
  const dispatch = useAppDispatch();

  const userType = useAppSelector(getTypeOfUser);

  const professionalRatingDetails = useAppSelector(rating);
  const professionalRatingData = useAppSelector(ratingItems);

  const pharmacyRatingDetails = useAppSelector(pharmacyRating);
  const pharmacyRatingData = useAppSelector(pharmacyRatingItems);

  const { userType: replacementType } = professionalRatingDetails ?? {};

  const replacementLabelConfig = {
    [HelpTypes.pharmacist]: strings.pharmacistsApos,
    [HelpTypes.technicians]: strings.techniciansApos,
    [HelpTypes.students]: strings.pharmacyStudentApos,
  };

  const label = replacementLabelConfig[
    (replacementType as keyof typeof replacementLabelConfig)
        ?? HelpTypes.pharmacist
  ];

  const professionalConfig = {
    ratingDetails: pharmacyRatingDetails,
    ratingData: pharmacyRatingData,
    getRatingItemsApi: getPharmacyRatingItems,
    getRatingApi: getPharmacyRating,
    successAction: professionalActions.rating,
    idProperty: 'pharmacyRatingItemId',
    itemProperty: 'pharmacyRatingItems',
    title: strings.pharmacyRating,
  };

  const config = {
    [pharmacist]: professionalConfig,
    [technician]: professionalConfig,
    [student]: professionalConfig,
    [pharmacy]: {
      ratingDetails: professionalRatingDetails,
      ratingData: professionalRatingData,
      getRatingItemsApi: getRatingItems,
      getRatingApi: getRating,
      successAction: pharmacyActions.rating,
      idProperty: 'professionalRatingItemId',
      itemProperty: 'professionalRatingItems',
      title: strings.formatString(strings.userRatingFormat, label),
    },
  };

  const {
    ratingData,
    ratingDetails,
    getRatingApi,
    getRatingItemsApi,
    successAction,
    idProperty,
    itemProperty,
    title,
  } = config[userType as keyof typeof config];

  useEffect(() => {
    dispatch(getRatingApi(id));
    dispatch(getRatingItemsApi(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ratingData,
    ratingDetails,
    successAction,
    idProperty,
    itemProperty,
    title,
  };
};

export default useViewRating;
